import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { selectThemeMode, selectUtcEnabled } from './Redux/Theme'
import { selectStartupIniting } from './Redux/Startup'
import { ToastContainer } from 'react-toastify'
import AppRouter from './Router'
import LoadingView from './Views/LoadingView'
import { TourProvider } from '@reactour/tour'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import * as R from 'ramda'
import Logger from '../Common/Utils/Logger'
import EventDispatcher from '../Common/Services/EventDispatcher'
import LocalStorageManagerModal from './Components/LocalStorageManagerModal'

// charts
import Highcharts from 'highcharts'
import HighchartsExporting from 'highcharts/modules/exporting'
import HighchartsExportData from 'highcharts/modules/export-data'

HighchartsExporting(Highcharts)
HighchartsExportData(Highcharts)

// Theme
import { ThemeProvider } from '@mui/material/styles'
import getTheme from '../Theme'

import 'react-toastify/dist/ReactToastify.css'
import { useEffect, useState } from 'react'

const App = ({ noStartup }) => {
  const startupIniting = useSelector(selectStartupIniting)
  const withLoading = R.ifElse(R.identity, () => <LoadingView />)
  const themeMode = useSelector(selectThemeMode)
  const theme = getTheme(themeMode)
  const utcEnabled = useSelector(selectUtcEnabled)
  const [localStorageModaIsOpen, setLocalStorageModalIsOpen] = useState(false)

  const handleOpenTour = target => {
    disableBodyScroll(target)
  }
  const handleCloseTour = target => {
    enableBodyScroll(target)
  }

  Logger.info('UTC enabled: ', utcEnabled)
  Logger.info('Theme mode: ', themeMode)

  // if exceeding localStorage quota, show modal to user so that they can free up space
  useEffect(() => {
    document.body.classList.add(`theme-${themeMode}`)
    EventDispatcher.register('localStorageQuotaExceeded', () => {
      setLocalStorageModalIsOpen(true)
    })
    return () => EventDispatcher.unregister('localStorageQuotaExceeded')
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <TourProvider
        steps={[]}
        styles={{
          popover: (base) => ({
            ...base,
            background: themeMode === 'light' ? '#fff' : '#444',
            color: themeMode === 'light' ? '#000' : '#fff',
          }),
        }}
        afterOpen={handleOpenTour}
        beforeClose={handleCloseTour}
        updateDelay={1000}
      >
        {withLoading(() => (
          <div>
            <ToastContainer theme={themeMode} />
            <AppRouter />
            {localStorageModaIsOpen && (
              <LocalStorageManagerModal onClose={() => setLocalStorageModalIsOpen(false)} />
            )}
          </div>
        ))(startupIniting && !noStartup)}
      </TourProvider>
    </ThemeProvider>
  )
}

App.defaultProps = {
  noStartup: false,
}

App.propTypes = {
  noStartup: PropTypes.bool,
}

export default App
